import React from 'react'

export function renderTracking(ctx) {
  const {
    accessLogs,
    activeTab,
    setTrackingFilter,
    t,
    trackingFilter,
  } = ctx
  return (
    <>
          {activeTab === 'tracking' && (
            <div className="dash-section">
              <div className="dash-section-header">
                <h2>📍 {t.tracking}</h2>
                <p>Real-time log of worker portal access — time, location, and device.</p>
              </div>
              <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                <input
                  className="dash-search-input"
                  placeholder="Filter by worker name..."
                  value={trackingFilter}
                  onChange={e => setTrackingFilter(e.target.value)}
                  style={{ maxWidth: 280 }}
                />
                <span style={{ fontSize: '0.85rem', color: '#6b7280' }}>{accessLogs.length} total entries</span>
              </div>
              <div style={{ overflowX: 'auto' }}>
                <table className="dash-table">
                  <thead>
                    <tr>
                      <th>Worker</th>
                      <th>Department</th>
                      <th>Access Time</th>
                      <th>Location</th>
                      <th>Device</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accessLogs
                      .filter(l => !trackingFilter || l.workerName?.toLowerCase().includes(trackingFilter.toLowerCase()))
                      .map(log => (
                        <tr key={log.id}>
                          <td><strong>{log.workerName}</strong></td>
                          <td style={{ color: '#6b7280' }}>{log.department || '—'}</td>
                          <td>{new Date(log.accessTime).toLocaleString()}</td>
                          <td>
                            {log.lat && log.lng
                              ? <span title={`${log.lat.toFixed(4)}, ${log.lng.toFixed(4)}`}>📍 {log.lat.toFixed(3)}, {log.lng.toFixed(3)}</span>
                              : <span style={{ color: '#9ca3af' }}>Not available</span>
                            }
                          </td>
                          <td style={{ fontSize: '0.78rem', color: '#6b7280', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {log.device ? log.device.slice(0, 60) + (log.device.length > 60 ? '…' : '') : '—'}
                          </td>
                        </tr>
                      ))
                    }
                    {accessLogs.length === 0 && (
                      <tr><td colSpan={5} style={{ textAlign: 'center', color: '#9ca3af', padding: '32px' }}>No access logs yet. Workers will be logged when they sign in.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
    </>
  )
}
